import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
  function getCookie(name) {
    // 使用document.cookie获取cookie，然后通过split分割出cookie值
    let cookieArr = document.cookie.split(';')
    for (let i = 0; i < cookieArr.length; i++) {
      let item = cookieArr[i].split('=')
      if (item[0].trim() === name) {
        return item[1]
      }
    }
    return ''
  }
  
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    hidden:false,
    redirect: '/oms/order',
    meta: {title: '首页', icon: 'home'},
    // children: [{
    //   path: 'home',
    //   hidden:true,
    //   name: 'home',
    //   component: () => import('@/views/home/index'),
    //   meta: {title: '首页', icon: 'dashboard'}
    // },
    // ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单发货', icon: 'product-list'}
      },{
        path: 'order_list',
        name: 'order_list',
        component: () => import('@/views/ord/order/index'),
        meta: {title: '订单清单', icon: 'product-list'}
      },
    ]
  }

]

export const asyncRouterMap = [
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js